import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
} from "alm-react-components";
import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../../../../assets/images/svgicons/trash.svg";
interface DeleteCommentModalProps {
  onDelete: (commentId: string) => void;
  id: string;
}
export const DeleteCommentModal: React.FC<DeleteCommentModalProps> = ({
  onDelete,
  id,
}) => {
  const { t } = useTranslation();

  const deleteAction = () => {
    onDelete(id);
  };
  return (
    <div>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="link" size="icon">
            <img
              src={TrashIcon}
              alt=""
              aria-label="back"
              className="logo h-5 w-5 mr-2 mt-[2px] trash-icon cursor-pointer"
            />
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-fillMidGrayCard border-0 py-10 px-16">
          <AlertDialogHeader>
            <AlertDialogTitle
              className="text-center mb-3 font-barlowMedium tracking-wide"
              dangerouslySetInnerHTML={{
                __html: t("DiscussionBoard.confirmMessage"),
              }}
            />

            <AlertDialogDescription
              className="text-base text-white font-barlowRegular"
              dangerouslySetInnerHTML={{
                __html: t("DiscussionBoard.deleteMessage"),
              }}
            />
          </AlertDialogHeader>
          <AlertDialogFooter className="lg:justify-center lg:space-x-5 my-3">
            <AlertDialogCancel
              className="w-full bg-transparent font-opensansSemiBold"
              dangerouslySetInnerHTML={{
                __html: t("Common.cancel"),
              }}
            />

            <AlertDialogAction
              onClick={deleteAction}
              className="w-full font-opensansSemiBold"
              dangerouslySetInnerHTML={{
                __html: t("Common.delete"),
              }}
            />
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
